import { useEffect, useState } from 'react'

import type { TextFieldProps } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'
import { fvDate } from '@fv/dates'

import { AdminTextField } from './AdminTextField'

export type AdminDateInputProps = Pick<
  TextFieldProps,
  'name' | 'required' | 'disabled'
> &
  PropsWithClassName<{
    value: Date | string
    onChange?: (value: Date) => void
  }>
export const AdminDateInput = ({
  className,
  value,
  onChange,
  ...rest
}: AdminDateInputProps) => {
  const [localVal, setLocalVal] = useState(fvDate(value).format('YYYY-MM-DD'))
  useEffect(() => {
    const parsed = fvDate(localVal, 'YYYY-MM-DD')
    const parsedYear = parsed.isValid() ? parsed.year() : NaN
    if (
      parsed.isValid() &&
      !isNaN(parsedYear) &&
      !parsed.isSame(value, 'day')
    ) {
      onChange?.(parsed.toDate())
    }
  }, [value, localVal, onChange])

  return (
    <AdminTextField
      {...rest}
      className={className}
      value={localVal}
      onChange={e => setLocalVal(e.target.value)}
      type="date"
    />
  )
}
